import Breadcrumb from '../../elements/breadcrumbs'
import { useDataSelector, useEntity } from '@uswitch/ev-utils/lib/context/selectors'

const BreadcrumbsConnected = props => {
  const rootEntity = useDataSelector(['rootEntity'])
  const breadcrumbs = useDataSelector(['breadcrumb'])
  const path = useDataSelector(['location', 'pathname'])
  const { homeTitle, homePath, showPageTitle } = useDataSelector(['meta', 'breadcrumbs'], {})

  const page = rootEntity.fields.link
  const pageEntity = useEntity(page)

  const [pageCrumb] = breadcrumbs.slice(-1)

  const crumbs = breadcrumbs.filter(bc => bc.fields.path !== path)
  const breadcrumbTitle =
    pageCrumb.fields.path === path ? pageCrumb.fields.displayText : pageEntity.title

  const breadcrumbsProps = {
    crumbs,
    title: showPageTitle ? breadcrumbTitle : null,
    ...(homeTitle ? { customHomeIcon: homeTitle } : {}),
    homePath,
    variant: props.variant || 'base',
  }

  return <Breadcrumb {...breadcrumbsProps} sx={{ variant: 'compounds.breadcrumbs' }} />
}

export default BreadcrumbsConnected
